export const LONG_NOTIFICATION_DURATION = 10_000;
